module.exports = __webpack_public_path__ + "static/media/dewaal.4187cff7.mp4";